import axios from "axios";

let http = axios.create({
  baseURL: process.env.VUE_APP_URL_API,
  // baseURL: "https://api-idemsaude.cosmoscode.com.br",
  // baseURL: "https://api.idemsaude.com.br/scnrevolution-dev/",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${
      localStorage.token ? JSON.parse(localStorage.token) : ""
    }`
  }
});

http.interceptors.request.use(
  function(config) {
    config.headers.Authorization = `Bearer ${
      localStorage.token ? JSON.parse(localStorage.token) : ""
    }`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default http;
